export default {"src":"/_next/static/media/IconographySet_Shop.b06e142b.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};